import React, { useMemo, useState } from 'react';
import cn from 'classnames';
import styles from './LabelEditor.module.scss';

export function NoteLabelEditor({
  label,
  updateLabel,
  hidden,
  appendBullet,
  onEnterKey,
  className,
}: {
  label: string | null;
  updateLabel: (label: string) => void;
  hidden?: boolean;
  appendBullet?: boolean;
  onEnterKey?: () => void;
  className?: string;
}) {
  const inputRef = React.useRef<HTMLSpanElement>(null);
  const [isEditing, setIsEditing] = useState(false);
  const defaultLabel = useMemo(() => label || '', [isEditing]);

  const showPlaceholder = !label;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      inputRef.current?.blur();
      onEnterKey?.();
    }
  };

  const handleInput = (e: React.FormEvent<HTMLDivElement>) => {
    if (!e.defaultPrevented) {
      updateLabel(e.currentTarget.textContent);
    }
  };

  if (!isEditing && hidden) {
    return null;
  }

  return (
    <>
      <div
        className={cn(
          styles.titleEditor,
          'note-title-editor',
          isEditing && styles.editing,
          className,
        )}
      >
        <span
          ref={inputRef}
          className={cn(styles.titleInput, !showPlaceholder && styles.noPlaceholder)}
          role="textbox"
          contentEditable
          onKeyDown={handleKeyDown}
          onInput={handleInput}
          onFocus={() => setIsEditing(true)}
          onBlur={() => setIsEditing(false)}
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          suppressContentEditableWarning
        >
          {defaultLabel}
        </span>
        <span className={cn(styles.placeholder, !showPlaceholder && styles.hidden)}>
          Add a label
        </span>
      </div>
      {appendBullet && (
        <>
          &nbsp;<small>&bull;</small>&nbsp;
        </>
      )}
    </>
  );
}
